module.exports = __webpack_public_path__ + "img/extraPayment.552bf448.svg";